import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { useTranslation as p } from "react-i18next";
import o from "@mui/material/Box";
import u from "@mui/material/Container";
import i from "@mui/material/Grid";
import x from "@mui/material/List";
import n from "@mui/material/ListItem";
import m from "@mui/material/Typography";
import { makeStyles as f } from "tss-react/mui";
import { useLanguageContext as g } from "@lumirental/lumi-web-shared/lib/contexts/Language.context";
import { manageSmoothScrolling as y } from "../../../../../utils/index.js";
import _ from "../../../../common/Button/Button.js";
import a from "../../../../common/Image/Image.js";
import b from "./FAQ.style.js";
import N from "../../list/FAQList/FAQList.js";
const v = f()(b), q = ({ listData: l }) => {
  const { classes: s } = v(), { t: r } = p(), { isArabic: c } = g(), d = `${s.listItemText} ${c ? s.arabicText : ""}`, h = () => {
    y("#reservationForm");
  };
  return /* @__PURE__ */ e(o, { py: { xs: 4, md: 15 }, className: s.wrapper, children: /* @__PURE__ */ e(u, { children: /* @__PURE__ */ t(i, { container: !0, columnSpacing: 12, children: [
    /* @__PURE__ */ t(
      i,
      {
        item: !0,
        xs: 12,
        sm: 12,
        md: 5,
        order: { xs: 2, sm: 2, md: 1 },
        py: { xs: 2, sm: 0 },
        children: [
          /* @__PURE__ */ t(o, { mb: { xs: 2, sm: 3 }, children: [
            /* @__PURE__ */ e(
              m,
              {
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block"
                },
                variant: "h1",
                mb: { xs: 4 },
                className: s.title,
                children: r("frequently_asked_questions_by_customers")
              }
            ),
            /* @__PURE__ */ e(
              m,
              {
                sx: { marginBottom: 2 },
                variant: "h3",
                className: s.contactTitle,
                children: r("for_more_questions")
              }
            ),
            /* @__PURE__ */ t(x, { sx: { padding: 0, marginBottom: 2 }, children: [
              /* @__PURE__ */ t(n, { className: s.listItem, children: [
                /* @__PURE__ */ e(o, { mr: { xs: 2 }, children: /* @__PURE__ */ e(
                  a,
                  {
                    src: "/images/png/phone-call.png",
                    width: 24,
                    height: 24
                  }
                ) }),
                /* @__PURE__ */ e(m, { variant: "body", className: d, children: r("umrah_mobile") })
              ] }),
              /* @__PURE__ */ t(n, { className: s.listItem, children: [
                /* @__PURE__ */ e(o, { mr: { xs: 2 }, children: /* @__PURE__ */ e(
                  a,
                  {
                    src: "/images/png/envelope.png",
                    width: 24,
                    height: 24
                  }
                ) }),
                /* @__PURE__ */ e(m, { variant: "body", className: s.listItemText, children: r("umrah_email") })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ e(
            _,
            {
              fullWidth: !0,
              dataTestid: "getAQuoteId",
              className: s.quoteBtn,
              onClick: h,
              children: r("get_a_quote!")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ t(
      i,
      {
        item: !0,
        xs: 12,
        sm: 12,
        md: 7,
        order: { xs: 1, sm: 1, md: 2 },
        py: { xs: 2, sm: 0 },
        children: [
          /* @__PURE__ */ e(
            m,
            {
              display: {
                sm: "block",
                md: "none"
              },
              variant: "h1",
              mb: { xs: 2 },
              className: s.title,
              children: r("frequently_asked_questions_by_customers")
            }
          ),
          /* @__PURE__ */ e(N, { listData: l })
        ]
      }
    )
  ] }) }) });
}, W = q;
export {
  W as default
};
